import useFetch from '@hooks/useFetch';
import { processLessonData } from '@api/processors/lesson';
import { useMemo } from 'react';

const getKey = (batchUID, epoch, timezoneDifference) => {
  return `v1/batch/${batchUID}/schedule/?offset=${epoch}&timezone_difference=${timezoneDifference}&limit=6`;
};

const useBatchSchedule = (batchUID) => {
  const key = useMemo(() => {
    const date = new Date();
    const timezoneDifference = date.getTimezoneOffset() * -1;
    const epoch = Math.floor(date.getTime() / 1000);
    return getKey(batchUID, epoch, timezoneDifference);
  }, [batchUID]);

  const {
    data: schedule,
    isValidating,
    ...rest
  } = useFetch(batchUID ? key : null);

  return {
    key,
    schedule: schedule?.results?.map(processLessonData),
    isValidating,
    ...rest
  };
};

export default useBatchSchedule;
